import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import LoaderImage from 'assets/images/loader-no-brand--dark.svg';
import LoaderImageGray from 'assets/images/loader-no-brand--gray.svg';
import { getCustomBrandingFromStorage } from 'helpers/customBranding';
const Loader = ({ isFullWith = false, gray = false }) => {
    const { t } = useTranslation();
    const customBranding = getCustomBrandingFromStorage();
    const blockLoader = () => _jsxs("div", Object.assign({ className: 'block--loader' }, { children: [_jsx("img", { className: 'image--loader--modal', src: (customBranding === null || customBranding === void 0 ? void 0 : customBranding.isEnabled) || gray ? LoaderImageGray : LoaderImage, alt: 'Loader' }, void 0), _jsx("div", Object.assign({ className: 'loader-code' }, { children: t('GENERAL.LOADING') }), void 0)] }), void 0);
    if (isFullWith) {
        return _jsx("div", Object.assign({ className: "container--main-content loader--fullscreen" }, { children: _jsx("div", Object.assign({ className: "container--loader-fullscreen" }, { children: blockLoader() }), void 0) }), void 0);
    }
    return blockLoader();
};
export default Loader;
